import _ from "lodash";
import moment from "moment";

const generateClientAppointmentsByTwelveWeekFilter = (twelveWeeksAfterFilter) => (clientAppointments) => {
  const twelveWeeksAfter = moment().add(12, "weeks");
  return clientAppointments.filter((ca) => {
    const creationTimestamp = _.get(ca, "creationTimestamp", "");
    const weeksToAppointment = parseInt(_.get(ca, "appointment_t.weeks_to_appointment", ""));
    if (_.isNaN(weeksToAppointment)) {
      return !twelveWeeksAfterFilter;
    }

    const appointmentDate = moment.unix(creationTimestamp).add(weeksToAppointment, "weeks");
    return twelveWeeksAfterFilter ? appointmentDate > twelveWeeksAfter : true;
  });
};

export default generateClientAppointmentsByTwelveWeekFilter;
